/* Rescuevation – Bewegungsebene für den ganzen Shop.
   Eingebunden über snippets/rescu-motion.liquid, Styles in rescu-motion.css.

   Erkennt die Bausteine jeder Seite an ihrer Struktur, ohne dass eine Section
   angepasst werden muss:
   - Kartenreihen: Raster/Flex-Container mit gleichartigen, kartengroßen Kindern
   - Bilder: freistehende Fotos ab Kartengröße (keine Hintergründe)
   - Köpfe: H2 samt Kicker und Einleitung, Zeile für Zeile gestaffelt
   - Kennzahlen: große, alleinstehende Zahlen zählen einmal hoch
   - Hover: verlinkte Karten heben sich, Bilder zoomen, Pfeile rücken nach

   Schutzschienen:
   - Jede Bewegung ist ADDITIV. Ohne JavaScript, bei reduzierter Bewegung und
     wenn ein Beobachter nie auslöst, bleibt alles im fertigen Zustand.
   - Bewegt wird nur, was von unten ins Bild kommt. Was beim Laden schon zu
     sehen ist oder per Ankersprung mitten im Bild landet, bleibt ruhig.
   - Nie angefasst: Kaufbereich, Preise, Formulare, Tabellen, Datenblätter,
     Slider, Ticker, klebende Leisten, Dawns eigene Einblendungen und alles mit
     eigener Animation.
   - Ein Element mit data-rm-aus nimmt sich samt Inhalt heraus. */
(function () {
  'use strict';
  if (window.__rescuMotion) return;
  window.__rescuMotion = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  /* Nie bewegen – weder das Element selbst noch etwas darin. */
  var AUS = [
    'header', 'footer', 'nav', 'form', 'table', 'dialog', 'details', 'summary',
    'iframe', 'select', 'product-info', 'product-form', 'variant-selects',
    '.product', '.product__info-wrapper', '.product__media-wrapper',
    '.scroll-trigger', '.card-wrapper', '.shopify-app-block',
    'slider-component', '.slider', '[class*="slider"]', '[class*="swiper"]',
    '[class*="karussell"]', '[class*="carousel"]', '[class*="ticker"]',
    '[class*="marquee"]', '[class*="sticky"]', '[class*="techdat"]',
    '[class*="tech-daten"]', '[class*="datenblatt"]', '[class*="kauf"]',
    '[data-rm-aus]', '[data-reveal]', '[data-vrd-zahl]', '.rescu-hero'
  ].join(',');

  /* Zahlen hierin zählen nie hoch (Preise, Datenblätter, Bedienelemente,
     Rechner-Ergebnisse und alles, was ein anderes Script live schreibt). */
  var ZAHL_AUS = [
    '[class*="price"]', '[class*="preis"]', '[class*="betrag"]',
    '[class*="spec"]', '[class*="daten"]', '[class*="rechner"]',
    '[class*="calc"]', '[aria-live]', 'output', 'dl', 'button', 'label',
    's', 'del', 'time'
  ].join(',');

  var NICHT_TEXT = 'img,picture,video,iframe,canvas,form,table,select,input,textarea';

  var main = document.getElementById('MainContent');
  if (!main) return;

  var vh = function () { return window.innerHeight || document.documentElement.clientHeight; };
  var vw = function () { return document.documentElement.clientWidth || window.innerWidth; };

  var art = new Map();      /* Element → Bewegungsart (auf, zoom, links, rechts) */
  var zahlen = new Map();   /* Element → Zähl-Auftrag */

  var stil = function (el) { return window.getComputedStyle(el); };
  var sichtbar = function (el) { return el.offsetWidth > 0 && el.offsetHeight > 0; };

  var inMarkiert = function (el) {
    for (var n = el; n && n !== main; n = n.parentElement) {
      if (art.has(n)) return true;
    }
    return false;
  };
  var enthaeltMarkiert = function (el) {
    var drin = false;
    art.forEach(function (_, m) { if (!drin && el !== m && el.contains(m)) drin = true; });
    return drin;
  };

  /* Darf dieses Element eine Einblendung bekommen? */
  var tauglich = function (el) {
    if (!sichtbar(el) || el.closest(AUS)) return false;
    var cs = stil(el);
    if (cs.animationName !== 'none') return false;          /* eigene Animation */
    if (parseFloat(cs.opacity) < 0.05) return false;        /* von fremdem Script versteckt */
    if (cs.position === 'fixed' || cs.position === 'sticky') return false;
    return true;
  };

  var nimm = function (el, wie) {
    if (art.has(el) || inMarkiert(el) || !tauglich(el)) return false;
    art.set(el, wie);
    return true;
  };

  /* ── Startseite: Richtungen wie in start-a ─────────────────────────────── */
  var RICHTUNG = [
    ['.rescu-award__media', 'links'],
    ['.rescu-award__content', 'rechts'],
    ['.rescu-wersind__foto', 'zoom']
  ];

  /* ── Kartenreihen ───────────────────────────────────────────────────────── */
  var signatur = function (k) { return k.tagName + '.' + (k.classList[0] || ''); };
  var reihen = [];

  var findeReihen = function () {
    var kandidaten = main.querySelectorAll('*');
    for (var i = 0; i < kandidaten.length; i++) {
      var el = kandidaten[i];
      var n = el.childElementCount;
      if (n < 2 || n > 30) continue;
      if (inMarkiert(el) || el.closest(AUS)) continue;

      var kinder = Array.prototype.filter.call(el.children, function (k) {
        return !/^(SCRIPT|STYLE|TEMPLATE|LINK|META|BR|HR)$/.test(k.tagName) && sichtbar(k);
      });
      if (kinder.length < 2) continue;
      if (kinder.some(function (k) { return k.classList.contains('shopify-section'); })) continue;

      /* Gleichartig: mindestens 60 % der Kinder tragen dieselbe Signatur. */
      var zaehler = {};
      var top = 0;
      kinder.forEach(function (k) {
        var s = signatur(k);
        zaehler[s] = (zaehler[s] || 0) + 1;
        if (zaehler[s] > top) top = zaehler[s];
      });
      if (top < 2 || top / kinder.length < 0.6) continue;

      var gross = kinder.filter(function (k) { return k.offsetWidth >= 120 && k.offsetHeight >= 56; });
      if (gross.length < 2) continue;

      var cs = stil(el);
      if (!/grid|flex/.test(cs.display)) continue;
      if (/auto|scroll/.test(cs.overflowX)) continue;      /* Wischreihe */

      var genommen = [];
      gross.forEach(function (k) { if (nimm(k, 'auf')) genommen.push(k); });
      if (genommen.length) reihen.push(genommen);
    }
  };

  /* ── Freistehende Bilder ───────────────────────────────────────────────── */
  var findeBilder = function () {
    main.querySelectorAll('img, video').forEach(function (m) {
      if (m.closest(AUS) || inMarkiert(m)) return;
      var r = m.getBoundingClientRect();
      if (r.width < 220 || r.height < 140) return;
      /* Rahmen: der äußerste Vorfahr, der genau so groß ist wie das Bild. */
      var rahmen = m;
      while (rahmen.parentElement && rahmen.parentElement !== main) {
        var p = rahmen.parentElement;
        var pr = p.getBoundingClientRect();
        if (Math.abs(pr.width - r.width) > 6 || Math.abs(pr.height - r.height) > 6) break;
        if (p.classList.contains('shopify-section')) break;
        rahmen = p;
      }
      if (rahmen.getBoundingClientRect().width > vw() * 0.9) return;     /* vollflächig */
      if (rahmen !== m && (rahmen.textContent || '').trim().length > 0) return; /* Bild mit Text darauf */
      if (/absolute|fixed/.test(stil(rahmen).position)) return;           /* Hintergrundbild */
      nimm(rahmen, 'zoom');
    });
  };

  /* ── Köpfe: H2 mit Kicker und Einleitung ──────────────────────────────── */
  var reinerText = function (el) {
    if (el === main || el.classList.contains('shopify-section')) return false;
    if (el.childElementCount > 7) return false;
    if (el.offsetHeight > vh() * 0.75) return false;
    if (el.querySelector(NICHT_TEXT)) return false;
    if (el.querySelectorAll('h2').length > 1) return false;
    if (el.closest(AUS) || inMarkiert(el) || enthaeltMarkiert(el)) return false;
    return true;
  };

  var findeKoepfe = function () {
    main.querySelectorAll('h2').forEach(function (h) {
      if (h.closest(AUS) || inMarkiert(h) || !sichtbar(h)) return;
      var kopf = h;
      while (kopf.parentElement && reinerText(kopf.parentElement)) kopf = kopf.parentElement;
      /* Reine Hüllen überspringen, damit Zeile für Zeile gestaffelt wird. */
      while (kopf !== h && kopf.childElementCount === 1) kopf = kopf.firstElementChild;
      if (kopf === h) { nimm(h, 'auf'); return; }
      Array.prototype.forEach.call(kopf.children, function (k) {
        if (/^(SCRIPT|STYLE|TEMPLATE|BR)$/.test(k.tagName)) return;
        nimm(k, 'auf');
      });
    });
  };

  /* ── Kennzahlen ────────────────────────────────────────────────────────── */
  /* Nur „+" als Vorzeichen: „>13 %" oder „~5 h" hochzuzählen liest sich schief. */
  var ZAHL_RE = /^(\+?\s?)(\d{1,3}(?:\.\d{3})+|\d+)(,\d+)?(.*)$/;

  var findeZahlen = function () {
    var walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT);
    var knoten;
    while ((knoten = walker.nextNode())) {
      var roh = knoten.nodeValue;
      var t = roh.trim();
      if (!t || t.length > 18) continue;
      var m = t.match(ZAHL_RE);
      if (!m) continue;
      var rest = m[4];
      if (/^\s?[\d\/:–\-x×.]/.test(rest)) continue;                 /* 24/7, 1:1, 2x */
      if (/€|eur|chf|pln|zł|\$/i.test(t)) continue;                  /* Preis */
      /* Höchstens eine kurze Einheit dahinter („1.400+", „150 h", „36.000 lm").
         „200 ml Tube" ist eine Produktgröße, keine Kennzahl (02.10.2026). */
      if (!/^\S{0,6}$/.test(rest.trim())) continue;
      var el = knoten.parentElement;
      if (!el || el.closest(AUS) || el.closest(ZAHL_AUS)) continue;
      if (el.closest('h1, h2')) continue;                             /* Überschrift, keine Kennzahl */
      /* Sections mit Eingabefeldern rechnen live – ihre Zahlen bleiben ruhig. */
      var section = el.closest('.shopify-section');
      if (section && section.querySelector('input, select, textarea')) continue;
      if ((el.textContent || '').trim().length > 24) continue;       /* steht im Fließtext */
      if (parseFloat(stil(el).fontSize) < 26) continue;              /* keine Großzahl */
      var mitPunkt = m[2].indexOf('.') !== -1;
      var stellen = m[3] ? m[3].length - 1 : 0;
      var wert = parseFloat(m[2].replace(/\./g, '') + (stellen ? '.' + m[3].slice(1) : ''));
      if (!isFinite(wert)) continue;
      if (!stellen && wert < 10) continue;                           /* einstellig: nichts zu zählen */
      if (!stellen && !mitPunkt && wert >= 1900 && wert <= 2100) continue; /* Jahreszahl */
      zahlen.set(el, {
        knoten: knoten,
        roh: roh,
        zahlText: m[2] + (m[3] || ''),
        wert: wert,
        stellen: stellen,
        gruppieren: mitPunkt
      });
    }
  };

  var zaehle = function (el) {
    var z = zahlen.get(el);
    if (!z || !z.knoten.isConnected || z.knoten.nodeValue !== z.roh) return;
    var fmt = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: z.stellen,
      maximumFractionDigits: z.stellen,
      useGrouping: z.gruppieren
    });
    var dauer = 1400;
    var start = null;
    var zuletzt = z.roh;
    el.classList.add('rm-zaehlt');
    var schritt = function (jetzt) {
      /* Hat ein anderes Script die Zahl inzwischen selbst geändert, gilt
         dessen Wert – sofort aufhören, nichts zurückschreiben. */
      if (z.knoten.nodeValue !== zuletzt) { el.classList.remove('rm-zaehlt'); return; }
      if (start === null) start = jetzt;
      var p = Math.min(1, (jetzt - start) / dauer);
      var e = 1 - Math.pow(1 - p, 3);
      if (p < 1) {
        zuletzt = z.roh.replace(z.zahlText, fmt.format(z.wert * e));
        z.knoten.nodeValue = zuletzt;
        window.requestAnimationFrame(schritt);
      } else {
        z.knoten.nodeValue = z.roh;                                  /* exakt der Originaltext */
        el.classList.remove('rm-zaehlt');
      }
    };
    window.requestAnimationFrame(schritt);
  };

  /* ── Hover: verlinkte Karten ───────────────────────────────────────────── */
  var ohneUebergang = function (el) {
    return stil(el).transitionDuration.split(',').every(function (d) { return parseFloat(d) === 0; });
  };
  var transparent = function (farbe) { return /rgba\(.*,\s*0\)$|transparent/.test(farbe); };

  var findeHover = function () {
    reihen.forEach(function (karten) {
      karten.forEach(function (k) {
        if (k.closest('.card-wrapper')) return;
        var a = k.matches('a[href]') ? k : k.querySelector('a[href]');
        if (!a) return;
        var flaecheK = k.offsetWidth * k.offsetHeight;
        if (a !== k && a.offsetWidth * a.offsetHeight < flaecheK * 0.6) return;
        if (!ohneUebergang(k)) return;
        var cs = stil(k);
        var bild = k.querySelector('img');
        var flaeche = !transparent(cs.backgroundColor) || parseFloat(cs.borderTopWidth) > 0 || cs.boxShadow !== 'none';
        if (!flaeche && !bild) return;
        k.classList.add('rm-karte');
        if (flaeche) k.classList.add('rm-flaeche');
        if (bild && ohneUebergang(bild) && stil(bild).transform === 'none') {
          var rahmen = bild.parentElement;
          if (rahmen && /hidden|clip/.test(stil(rahmen).overflow)) bild.classList.add('rm-zoombild');
        }
      });
    });
    /* Pfeile in Links, die noch keine eigene Bewegung haben. */
    main.querySelectorAll('a [class*="__pfeil"], a [class*="__arrow"], a .icon-arrow').forEach(function (p) {
      if (p.closest(AUS)) return;
      if (ohneUebergang(p) && stil(p).transform === 'none') p.classList.add('rm-pfeil');
    });
  };

  /* ── Auslösen ──────────────────────────────────────────────────────────── */
  var KLASSEN = ['rm-auf', 'rm-zoom', 'rm-links', 'rm-rechts'];

  var starte = function (el, verzug) {
    var wie = art.get(el);
    art.delete(el);
    if (!wie) return;
    el.style.setProperty('--rm-d', verzug + 'ms');
    el.classList.add('rm-' + wie);
    var fertig = false;
    var ende = function () {
      if (fertig) return;
      fertig = true;
      KLASSEN.forEach(function (k) { el.classList.remove(k); });
      el.style.removeProperty('--rm-d');
      el.removeEventListener('animationend', beiEnde);
    };
    var beiEnde = function (ev) {
      if (ev.target === el && !ev.pseudoElement && ev.animationName.indexOf('rm-') === 0) ende();
    };
    el.addEventListener('animationend', beiEnde);
    window.setTimeout(ende, verzug + 1200);
  };

  var beobachter = new IntersectionObserver(function (eintraege) {
    var h = vh();
    var kommend = [];
    eintraege.forEach(function (e) {
      if (!e.isIntersecting) return;
      beobachter.unobserve(e.target);
      var top = e.boundingClientRect.top;
      /* Nur was von unten hereinkommt. Ankersprung oder Hochscrollen: ruhig. */
      if (top < h - 160 || top > h + 120) { art.delete(e.target); return; }
      kommend.push(e.target);
    });
    kommend.sort(function (a, b) {
      var ra = a.getBoundingClientRect();
      var rb = b.getBoundingClientRect();
      return (Math.round(ra.top / 8) - Math.round(rb.top / 8)) || (ra.left - rb.left);
    });
    kommend.forEach(function (el, i) {
      if (art.has(el)) starte(el, Math.min(i, 6) * 70);
      if (zahlen.has(el)) zaehle(el);
    });
  }, { rootMargin: '0px 0px 60px 0px', threshold: 0 });

  var los = function () {
    RICHTUNG.forEach(function (paar) {
      main.querySelectorAll(paar[0]).forEach(function (el) { nimm(el, paar[1]); });
    });
    findeReihen();
    findeBilder();
    findeKoepfe();
    findeZahlen();
    findeHover();

    var h = vh();
    var beobachtet = new Set();
    var beobachte = function (el) {
      if (beobachtet.has(el)) return;
      var r = el.getBoundingClientRect();
      /* Was beim Start schon (teilweise) im Bild ist, bleibt, wie es ist. */
      if (r.top < h) return;
      beobachtet.add(el);
      beobachter.observe(el);
    };
    Array.from(art.keys()).forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < h) { art.delete(el); return; }
      beobachte(el);
    });
    Array.from(zahlen.keys()).forEach(beobachte);

    document.documentElement.setAttribute('data-rm', String(beobachtet.size));
  };

  /* Erst nach dem Laden: vorher stehen Bildhöhen nicht fest und Elemente
     gelten fälschlich als schon sichtbar. Spätestens nach 3 s geht es los. */
  var gestartet = false;
  var einmal = function () { if (!gestartet) { gestartet = true; los(); } };
  if (document.readyState === 'complete') {
    einmal();
  } else {
    window.addEventListener('load', einmal, { once: true });
    window.setTimeout(einmal, 3000);
  }
})();
